import { FC, SVGAttributes } from 'react';

const Star: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <svg {...props} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.92021 2.78762L11.4431 5.68675C11.5923 5.97136 11.8804 6.16871 12.2145 6.21438L15.6211 6.68166C16.4628 6.79747 16.7977 7.76955 16.1886 8.32654L13.7252 10.5822C13.4831 10.804 13.3729 11.1229 13.4301 11.4361L14.0115 14.6206C14.1547 15.4084 13.2748 16.0094 12.5225 15.6367L9.47768 14.1321C9.17918 13.9845 8.82168 13.9845 8.52232 14.1321L5.4775 15.6367C4.72519 16.0094 3.84533 15.4084 3.98937 14.6206L4.56987 11.4361C4.62714 11.1229 4.51694 10.804 4.27485 10.5822L1.8114 8.32654C1.20226 7.76955 1.5372 6.79747 2.37889 6.68166L5.78554 6.21438C6.11961 6.16871 6.40856 5.97136 6.55781 5.68675L8.07979 2.78762C8.45638 2.07079 9.54362 2.07079 9.92021 2.78762Z"
                stroke="currentColor"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Star;
